import { fabric } from 'fabric';

export class FabricShape {
    constructor(canvas, options = {
        type: 'rect',
        isDrawing: false,
        class: 'shape',
        fillColor: 'rgba(255, 202, 65, 0.5)',
        strokeColor: '#FFFFFF',
        time: 0
    }, callbacks) {
        this.canvas = canvas;
        this.callbacks = callbacks || {};
        this.type = options.type;
        this.className = options.class;
        this.isDrawing = options.isDrawing || false;
        this.options = options;
        this.isEdit = false;
        this.origX = 0;
        this.origY = 0;
        this.bindEvents();
        this.canvas.discardActiveObject();
    }

    bindEvents = () => {
        this.canvas.on('mouse:down', (o) => { this.onMouseDown(o); });
        this.canvas.on('mouse:move', (o) => { this.onMouseMove(o); });
        this.canvas.on('mouse:up', (o) => { this.onMouseUp(o); });
        this.canvas.on('object:moving', (o) => { this.enableEdit(); });
        this.canvas.on('object:modified', (o) => { this.enableEdit(); });
        this.canvas.on('object:scaling', (o) => { this.enableEdit(); });
        // this.canvas.on('object:selected', this.callbacks.selected);
        this.canvas.on('selection:cleared', this.callbacks.selected)
        this.canvas.on('selection:updated', this.callbacks.selected)
        this.canvas.on('selection:created', this.callbacks.selected)

        this.canvas.on('object:added', (o) => { if (!this.isEdit) this.callbacks.created(o) })
    }

    onMouseUp = (o) => {
        this.disableDrawing();
    };

    onMouseMove = (o) => {
        if (!this.isEnable()) { return; }
        var pointer = this.canvas.getPointer(o.e);
        var activeObj = this.canvas.getActiveObject();

        if (activeObj) {
            activeObj.stroke = this.options.strokeColor;
            activeObj.fill = this.options.fillColor;
            activeObj.strokeWidth = 2;

            if (this.origX > pointer.x) {
                activeObj.set({ left: Math.abs(pointer.x) });
            }
            if (this.origY > pointer.y) {
                activeObj.set({ top: Math.abs(pointer.y) });
            }

            activeObj.set({ width: Math.abs(this.origX - pointer.x) });
            activeObj.set({ height: Math.abs(this.origY - pointer.y) });

            activeObj.setCoords();
            this.canvas.renderAll();
        }
    };

    onMouseDown = (o) => {
        if (this.isEnable()) {
            this.enableDrawing();

            var pointer = this.canvas.getPointer(o.e);
            this.origX = pointer.x;
            this.origY = pointer.y;

            const shapeOptions = {
                left: this.origX,
                top: this.origY,
                originX: 'left',
                originY: 'top',
                width: pointer.x - this.origX,
                height: pointer.y - this.origY,
                angle: 0,
                transparentCorners: false,
                hasBorders: true,
                hasControls: true,
                hasRotatingPoint: false,
                cornerColor: '#4CF4FF',
                cornerSize: 5,
                padding: 2,
                time: this.options.time,
                id: JSON.stringify({
                    time: this.options.time,
                    x: this.origX,
                    y: this.origY,
                })
            }

            var shape;
            if (this.type === 'rect')
                shape = new fabric.Rect(shapeOptions);
            else if (this.type === 'circle')
                shape = new fabric.Rect({ ...shapeOptions, rx: 500 });
            else
                shape = new fabric.Rect(shapeOptions);

            this.canvas.add(shape).setActiveObject(shape);
        }
    };

    isEnable = () => {
        return !this.isEdit && this.isDrawing;
    }

    enableDrawing = () => {
        this.isDrawing = true;
    }

    disableDrawing = () => {
        this.isDrawing = false;
    }

    enableEdit = () => {
        this.isEdit = true;
        this.disableDrawing();
    }

    disableEdit = () => {
        this.isEdit = false;
    }
}

export class DrawPolygon {
    constructor(canvas, options, callbacks) {
        this.canvas = canvas;
        this.callbacks = callbacks;
        this.options = options;
        this.min = 99;
        this.max = 999999;
        this.polygonMode = true;
        this.pointArray = [];
        this.lineArray = [];
        this.activeLine = {};
        this.activeShape = false;
        this.bindEvents();
    }

    bindEvents = () => {
        this.canvas.on('mouse:down', (o) => { this.onMouseDown(o); });
        this.canvas.on('mouse:move', (o) => { this.onMouseMove(o); });
        this.canvas.on('mouse:up', (o) => { this.onMouseUp(o); });
        this.canvas.on('mouse:dblclick', (o) => { this.onMouseDblClick(o); });

        this.canvas.on('selection:cleared', this.callbacks.selected)
        this.canvas.on('selection:updated', this.callbacks.selected)
        this.canvas.on('selection:created', this.callbacks.selected)

        this.canvas.on('object:added', (o) => { if (o.target.class == 'polygon' && o.target.id) this.callbacks.created(o) })
    }

    onMouseDown = (options) => {
        if (options.target && options.target.id == this.pointArray[0].id) {
            this.generatePolygon(this.pointArray);
        }
        if (this.polygonMode) {
            this.addPoint(options);
        }
    }

    onMouseDblClick = (options) => {
        if (this.activeLine && this.activeLine.class == "line") {
            this.generatePolygon(this.pointArray);
        }
    }

    onMouseUp = (options) => {

    }

    onMouseMove = (options) => {
        if (this.activeLine && this.activeLine.class == "line") {
            var pointer = this.canvas.getPointer(options.e);
            this.activeLine.set({ x2: pointer.x, y2: pointer.y });

            var points = this.activeShape.get("points");
            points[this.pointArray.length] = {
                x: pointer.x,
                y: pointer.y
            }
            this.activeShape.set({
                points: points
            });
            this.canvas.renderAll();
        }
        this.canvas.renderAll();
    }

    drawPolygon = () => {
        this.polygonMode = true;
        this.pointArray = new Array();
        this.lineArray = new Array();
        // activeLine;
    }

    addPoint = (options) => {
        var random = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
        var id = new Date().getTime() + random;
        var circle = new fabric.Circle({
            radius: 3,
            fill: '#4CF4FF',
            stroke: '#333333',
            class: 'point',
            strokeWidth: 0,
            left: (options.e.layerX / this.canvas.getZoom()),
            top: (options.e.layerY / this.canvas.getZoom()),
            selectable: false,
            hasBorders: false,
            hasControls: false,
            originX: 'center',
            originY: 'center',
            id: id,
            objectCaching: false
        });
        if (this.pointArray.length == 0) {
            circle.set({
                fill: '#FFFFFF',
                stroke: '#4CF4FF',
                strokeWidth: 0.5,
                radius: 5
            })
        }
        var points = [(options.e.layerX / this.canvas.getZoom()), (options.e.layerY / this.canvas.getZoom()), (options.e.layerX / this.canvas.getZoom()), (options.e.layerY / this.canvas.getZoom())];
        var line = new fabric.Line(points, {
            strokeWidth: 1,
            fill: this.options.fillColor,
            stroke: '#FFFFFF',
            class: 'line',
            originX: 'center',
            originY: 'center',
            selectable: false,
            hasBorders: false,
            hasControls: false,
            evented: false,
            objectCaching: false
        });
        if (this.activeShape) {
            var pos = this.canvas.getPointer(options.e);
            var points = this.activeShape.get("points");
            points.push({
                x: pos.x,
                y: pos.y
            });
            var polygon = new fabric.Polygon(points, {
                stroke: this.options.strokeColor,
                strokeWidth: 1,
                fill: this.options.fillColor,
                opacity: 1,
                class: 'polygon',
                selectable: false,
                hasBorders: false,
                hasControls: false,
                evented: false,
                objectCaching: false
            });
            this.canvas.remove(this.activeShape);
            this.canvas.add(polygon);
            this.activeShape = polygon;
            this.canvas.renderAll();
        }
        else {
            var polyPoint = [{ x: (options.e.layerX / this.canvas.getZoom()), y: (options.e.layerY / this.canvas.getZoom()) }];
            var polygon = new fabric.Polygon(polyPoint, {
                stroke: this.options.strokeColor,
                strokeWidth: 1,
                fill: this.options.fillColor,
                opacity: 0.3,
                class: 'polygon',
                selectable: false,
                hasBorders: false,
                hasControls: false,
                evented: false,
                objectCaching: false
            });
            this.activeShape = polygon;
            this.canvas.add(polygon);
        }
        this.activeLine = line;

        this.pointArray.push(circle);
        this.lineArray.push(line);

        this.canvas.add(line);
        this.canvas.add(circle);
        this.canvas.selection = false;
    }

    generatePolygon = (pointArray) => {
        var points = new Array();
        pointArray.map(point => {
            points.push({
                x: point.left,
                y: point.top
            });
            this.canvas.remove(points);
            this.canvas.remove(point);
        });

        this.lineArray.map(line => {
            this.canvas.remove(line);
        });

        this.canvas.remove(this.activeShape).remove(this.activeLine);

        var polygon = new fabric.Polygon(points, {
            stroke: this.options.strokeColor,
            strokeWidth: 0.5,
            fill: this.options.fillColor,
            opacity: 1,
            angle: 0,
            class: 'polygon',
            transparentCorners: false,
            hasBorders: true,
            hasControls: true,
            hasRotatingPoint: false,
            cornerColor: '#4CF4FF',
            cornerSize: 5,
            padding: 2,
            time: this.options.time,
            id: JSON.stringify({
                time: this.options.time,
                points: points
            })
        });
        this.canvas.add(polygon);
        this.activeLine = null;
        this.activeShape = null;
        this.polygonMode = false;
        // this.canvas.selection = true;
    }
}

// Extended fabric line class
fabric.LineArrow = fabric.util.createClass(fabric.Line, {

    type: 'lineArrow',

    initialize: function (element, options) {
        options || (options = {});
        this.callSuper('initialize', element, options);
    },

    toObject: function () {
        return fabric.util.object.extend(this.callSuper('toObject'));
    },

    _render: function (ctx) {
        this.ctx = ctx;
        this.callSuper('_render', ctx);
        let p = this.calcLinePoints();
        let xDiff = this.x2 - this.x1;
        let yDiff = this.y2 - this.y1;
        let angle = Math.atan2(yDiff, xDiff);
        this.drawArrow(angle, p.x2, p.y2);
        ctx.save();
        // xDiff = -this.x2 + this.x1;
        // yDiff = -this.y2 + this.y1;
        // angle = Math.atan2(yDiff, xDiff);
        // this.drawArrow(angle, p.x1, p.y1);
    },

    drawArrow: function (angle, xPos, yPos) {
        this.ctx.save();
        this.ctx.translate(xPos, yPos);
        this.ctx.rotate(angle);
        this.ctx.beginPath();
        // Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
        this.ctx.moveTo(10, 0);
        this.ctx.lineTo(-15, 15);
        this.ctx.lineTo(-15, -15);
        this.ctx.closePath();
        this.ctx.fillStyle = this.stroke;
        this.ctx.fill();
        this.ctx.restore();
    }
});



// fabric.LineArrow.fromObject = function (object, callback) {
//     callback && callback(new fabric.LineArrow([object.x1, object.y1, object.x2, object.y2], object));
// };

// fabric.LineArrow.async = true;

export class DrawArrow {
    constructor(canvas, options, callbacks) {
        this.canvas = canvas;
        this.options = options;
        this.callbacks = callbacks;
        this.className = 'arrow';
        this.isDrawing = this.options.isDrawing;
        this.isEdit = false;
        this.bindEvents();
        this.canvas.discardActiveObject();
    }

    bindEvents = () => {
        this.canvas.on('mouse:down', (o) => { this.onMouseDown(o); });
        this.canvas.on('mouse:move', (o) => { this.onMouseMove(o); });
        this.canvas.on('mouse:up', (o) => { this.onMouseUp(o); });
        this.canvas.on('object:moving', (o) => { this.disableDrawing(); });

        // this.canvas.on('object:moving', (o) => { this.enableEdit(); });
        this.canvas.on('object:modified', (o) => { this.enableEdit(); });
        this.canvas.on('object:scaling', (o) => { this.enableEdit(); });

        // this.canvas.on('selection:cleared', this.callbacks.selected)
        // this.canvas.on('selection:updated', this.callbacks.selected)
        this.canvas.on('selection:created', this.callbacks.selected)

        this.canvas.on('object:added', this.callbacks.created)
    }

    onMouseDown = (o) => {
        if (this.isEnable()) {
            this.enableDrawing();
            var pointer = this.canvas.getPointer(o.e);

            var points = [pointer.x, pointer.y, pointer.x, pointer.y];
            this.line = new fabric.LineArrow(points, {
                strokeWidth: 2,
                fill: this.options.fillColor,
                stroke: this.options.strokeColor,
                originX: 'center',
                originY: 'center',
                angle: 0,
                class: 'arrow',
                transparentCorners: false,
                hasBorders: true,
                hasControls: true,
                hasRotatingPoint: false,
                cornerColor: '#4CF4FF',
                cornerSize: 5,
                padding: 2,
                time: this.options.time,
                id: JSON.stringify({
                    time: this.options.time,
                    points: points
                }),
                objectCaching: false,
                perPixelTargetFind: true
            });

            this.canvas.add(this.line).setActiveObject(this.line);
        }
    }

    onMouseUp = (o) => {
        this.line.set({
            dirty: true,
            needsItsOwnCache: function() {
                return true;
            },
        });
        // this.canvas.renderAll();
        this.disableDrawing();
    }

    onMouseMove = (o) => {
        if (this.isEnable()) {
            var pointer = this.canvas.getPointer(o.e);
            var activeObj = this.canvas.getActiveObject();
            if(activeObj) {
                activeObj.set({
                    x2: pointer.x,
                    y2: pointer.y
                });
                activeObj.setCoords();
            }
            this.canvas.renderAll();
        }
    }

    isEnable = () => {
        return !this.isEdit && this.isDrawing;
    }

    enableDrawing = () => {
        this.isDrawing = true;
    }

    disableDrawing = () => {
        this.isDrawing = false;
    }

    enableEdit = () => {
        this.isEdit = true;
        this.disableDrawing();
    }

    disableEdit = () => {
        this.isEdit = false;
    }
}